import * as React from 'react';

import { usePathType, useUndergroundIcon } from './hooks';
import * as styles from './Underground.css';
import { IUnderground } from '../../../types/promosPage';

interface IUndergroundProps {
  underground: IUnderground;
}

export const Underground: React.FC<IUndergroundProps> = ({ underground }) => {
  const { lineColor, path, stationName, undergroundType } = underground;

  const undergroundIcon = useUndergroundIcon(undergroundType);
  const transportType = usePathType(path.pathType);

  return (
    <div className={styles['underground']}>
      <div className={styles['underground-name']}>
        <div className={styles['underground-icon']} style={{ color: lineColor }}>
          {undergroundIcon}
        </div>
        {stationName}
      </div>
      <div className={styles['underground-time']}>
        {transportType}
        {path.text}
      </div>
    </div>
  );
};
